export default class Pago {
    constructor(pago) {
        this.tipo_pago_id = pago.tipo_pago_id || '',
        this.fecha = pago.fecha || '',
        this.numero_documento = pago.numero_documento || '';
        this.monto = pago.monto || '';
        this.soporte = pago.soporte || '';
        this.pedido_id = pago.pedido_id || '';
    }
}


/** WEBPACK FOOTER **
 ** ./app-react/Models/Pago.js
 **/